export default "__VITE_ASSET__BqOymeIm__"